import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, Validator, FormControl, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {OrderService} from '../../../service/order-service';

@Component({
  selector: 'province-select',
  templateUrl: './province-select.component.html',
  styleUrls: ['./province-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProvinceSelectComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProvinceSelectComponent),
      multi: true
    }
  ]
})
export class ProvinceSelectComponent implements ControlValueAccessor, Validator {
  provincesList:any[] = [];
  districtsList:any[] = [];
  communesList:any[] = [];

  private provinceData: {provinceId?: number, districtId?: number, communeId?: number};

  private storeData: {provinceId: number, districtId: number, communeId: number};

  onChange: (selectedData: any) => void;
  onTouched: () => void;
  isDisabled: boolean;
  @Input('type') type: 'central' | 'province';
  @Input() className: 'form-control form-control-lg form-control-solid';

  constructor(
    private orderService: OrderService,
  ) {
    this.getProvinces();
    this.storeData = { provinceId: null, districtId: null, communeId: null };
    console.log('init province control');
  }
  getProvinces() {
    this.orderService.getProvincesDisplay().subscribe(res => {
      if (res !== null) {
        this.provincesList = res;
      }
    }, error => {
      console.error("Cannot get list provinces!!!");
    });
  }
  isSelectProvince(provinceId: number): boolean {
    return !this.provinceData ? false : (provinceId === this.provinceData.provinceId);
  }
  isSelectDistrict(districtId: number): boolean {
    return !this.provinceData ? false : (districtId === this.provinceData.districtId);
  }
  isSelectCommune(communeId: number): boolean {
    return !this.provinceData ? false : (communeId === this.provinceData.communeId);
  }

  writeValue(obj: any) {
    //console.log('write value', this.storeData);
    this.storeData = this.provinceData = obj;
    if (obj && obj.provinceId) {
      this.orderService.getDistrictsDisplay(obj.provinceId).subscribe(res => {
        if (res !== null) {
          this.districtsList = res;
          if (obj && obj.districtId) {
            this.orderService.getCommunesDisplay(obj.districtId).subscribe(res => {
              if (res !== null) {
                this.communesList = res;
              }
            }, error => {
              console.error("Cannot get list districts!!!");
            });
          }
        }
      }, error => {
        console.error("Cannot get list districts!!!");
      });
    }
    /*if (obj && obj.districtId){
      this.handleOnDistrictChange({target: {value: obj.districtId}});
    }*/
  }

  registerOnChange(fn: (provinceData: any) => void) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void) {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.isDisabled = isDisabled;
  }

  handleOnProvinceChange(e) {
    const provinceId = parseInt(e.target.value);
    this.storeData.provinceId = provinceId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getDistrictsDisplay(provinceId).subscribe(res => {
      if (res !== null) {
        this.districtsList = res;
        if (this.districtsList.length > 0){
          this.handleOnDistrictChange({target: {value: this.districtsList[0].id}});
        }
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  handleOnDistrictChange(e) {
    const districtId = parseInt(e.target.value);
    this.storeData.districtId = districtId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);

    this.orderService.getCommunesDisplay(districtId).subscribe(res => {
      if (res !== null) {
        this.communesList = res;
      }
    }, error => {
      console.error("Cannot get list districts!!!");
    });
  }
  handleOnCommuneChange(e) {
    const communeId = parseInt(e.target.value);
    this.storeData.communeId = communeId;
    this.writeValue(this.storeData);
    this.onChange(this.storeData);
  }

  validate(c: FormControl) {
    return null;
    /*if (!this.type || !this.provinceData) {
      return null;
    }
    return this.provinceData.type === this.type ? null : {
      type: {
        valid: false,
        actual: c.value
      }
    }*/
  }
}
